export const marqueeCoverUrls = [
  // January
  "https://a.bracky.app/assets/covers/cfb/cfb-playoff-2026.jpg",
  // February
  "https://a.bracky.app/assets/covers/nfl/super-bowl-2026.jpg",
  "https://a.bracky.app/assets/covers/nfl/defensive-mvp-2026.jpg",
  // March
  "https://a.bracky.app/assets/covers/ncaab/ncaa-march-madness-2026.jpg",
  "https://a.bracky.app/assets/covers/f1/f1.jpg",
  // April
  "https://a.bracky.app/Bracket%20Covers/2025-Masters.jpg",
  "https://a.bracky.app/Bracket%20Covers/2025-nba-playoffs.jpg",
  "https://a.bracky.app/Bracket%20Covers/2025-nhl-winner.jpg",
  // May
  "https://a.bracky.app/Bracket%20Covers/20250516%20-%20PGA-Championship.jpg",
  "https://a.bracky.app/Bracket%20Covers/2025-champions-league-cover.jpg",
  // June
  "https://a.bracky.app/assets/covers/golf/us-open-2025.jpg",
  "https://a.bracky.app/assets/covers/soccer/fifa-men/fifa-world-cup-2026.webp",
  // July
  "https://a.bracky.app/assets/covers/golf/the-open.webp",
  "https://a.bracky.app/assets/covers/cycling/tour-de-france.webp",
  "https://a.bracky.app/assets/covers/soccer/fifa-men/fifa-club-world-cup-2025.webp",
  "https://a.bracky.app/assets/covers/soccer/epl/premier-league.webp",
  "https://a.bracky.app/assets/covers/combat/ufc/ufc.webp",
  // October
  "https://a.bracky.app/assets/covers/mlb/world-series.webp",
]

export const marqueeConfig = {
  defaultSpeed: 100, // pixels per second
  arcRatio: 0.35, // Arc amplitude as ratio of cover height
  defaultCoverHeight: 96,
  keyframesName: "bracketMarquee",
  styleId: "bracket-marquee-keyframes",
  coverSizes: {
    mobile: "h-[2.8rem] w-[2.8rem]",
    sm: "sm:h-12 sm:w-12",
    md: "md:h-[3.7rem] md:w-[3.7rem]",
    mdlg: "mdlg:h-[4.2rem] mdlg:w-[4.2rem]",
    lg: "lg:h-[4.8rem] lg:w-[4.8rem]",
    xl: "xl:h-[5.28rem] xl:w-[5.28rem]",
  },
}

export function formatCoverTitle(url: string): string {
  const fileName = decodeURIComponent(url.split("/").pop() ?? "")
    .replace(/\.[^/.]+$/, "") // remove extension
    .replace(/[-_]/g, " ") // replace dashes/underscores with spaces
  return fileName.replace(/\b\w/g, (char) => char.toUpperCase())
}
